import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { Button, Flex } from 'core/ui/atoms';
import Money from 'core/api/Money';

const PaymentButton = ({ userSwapBillingSummary, finalAmount, onComplete }) => {
  const { totalAddonsCount, totalSwapsCount, creditsTotalAmount } = userSwapBillingSummary;
  const isButtonDisabled = totalAddonsCount === 0 && totalSwapsCount === 0;

  const buttonText = creditsTotalAmount?.amount < 0
    ? 'CREDIT' : finalAmount?.amount === 0
    ? 'CONFIRM ORDER' : 'PAY NOW';

  const totalAmount = creditsTotalAmount?.amount < 0 && finalAmount?.amount === 0 ?
    { __typename: 'Money', amount: Math.abs(creditsTotalAmount?.amount) } :
    { __typename: 'Money', amount: finalAmount?.amount };

  return (
    <PaymentContainer>
      <StyledPaymentButton onClick={onComplete} disabled={isButtonDisabled}>
        {buttonText} {totalAmount?.amount !== 0 && `- ${Money(totalAmount).toFormat('$0,0')}`}
      </StyledPaymentButton>
    </PaymentContainer>
  );
};

PaymentButton.propTypes = {
  userSwapBillingSummary: PropTypes.object,
  finalAmount: PropTypes.object,
  onComplete: PropTypes.func.isRequired,
};

const PaymentContainer = styled(Flex)`
  display: flex;
  justify-content: center;
  position: unset;
  width: 100%;
  padding: 20px;
  height: 80px;
  ${(p) => p.theme.max('sm')`
    background-color: ${(p) => p.theme.colors.creamWhite};
    position: fixed;
    bottom: 0;
    left: 0;
  `}
`;

const StyledPaymentButton = styled(Button)`
  padding: 12px 10px;
  border-radius: 4px;
  display: flex;
  width: 85%;
  justify-content: center;
  align-items: center;
  gap: 10px;
  background: ${(p) => p.theme.colors.green.light};
  ${(p) => p.theme.max('sm')`
    margin-bottom: 0;
  `}
`;

export default PaymentButton;
